import type { LangsType } from '@Types/Shared/SiteDatas';

import { cn } from '@Blocks/_components/ui/utils';

import { Link } from '@inertiajs/react';

import { MenuChildCaretSmall } from '../../Icons';

export default function Langs({
	langs,
	itemClass,
	variantMenuChildItems,
}: {
	langs: LangsType;
	itemClass: any;
	variantMenuChildItems: string | undefined;
}) {
	const childClass =
		"first:before:hidden before:content-[''] before:w-full before:h-0.5 before:block before:bg-minos-header-topnav-icon-color before:mb-3.5";

	let gapItemChild = 'gap-5';

	if (variantMenuChildItems === 'separation') {
		gapItemChild = 'gap-3.5';
	}

	return (
		<div className={`group relative ${variantMenuChildItems === 'arrow' ? 'py-1.5' : ''}`}>
			<button className={`mx-auto flex items-center gap-2 ${itemClass.menuItems}`}>
				{langs.current}
				<MenuChildCaretSmall
					className={cn(
						'inline-bloc rotate-0 group-hover:rotate-180 transition-all',
						itemClass.iconColor
					)}
				/>
			</button>
			<ul
				className={cn(
					'w-full desktop:w-auto invisible relative desktop:absolute top-full left-1/2 z-40 -translate-x-1/2 p-4 flex flex-col items-center group-hover:visible',
					gapItemChild,
					itemClass.menuChildBg,
					itemClass.menuChildRadius
				)}
			>
				{variantMenuChildItems === 'arrow' && (
					<div className='absolute -top-1.5 left-1/2 z-40 -translate-x-1/2'>
						<svg
							width='10'
							height='7'
							viewBox='0 0 9 6'
							xmlns='http://www.w3.org/2000/svg'
							className={itemClass.menuChildSvg}
						>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M4.48186 0.585693L8.96373 5.58569H0L4.48186 0.585693Z'
							/>
						</svg>
					</div>
				)}
				{Object.entries(langs.others).map(([key, lang]) => (
					<li key={key} className={`${variantMenuChildItems === 'separation' ? childClass : ''}`}>
						<Link className={itemClass.childMenuItems} href={lang.url}>
							{lang.slug}
						</Link>
					</li>
				))}
			</ul>
		</div>
	);
}
